import React, { useEffect, useState } from "react";
import { Spin } from "antd";
import SubscribeFormDialog from "../../components/SubscribeFormDialog";
import CarouselTopPicks from "./CarouselTopPicks";
import { useData } from "../../contexts/DataContext";
import { fetchHomePage } from "../../services/ApiService";
import FollowMeBanner from "../../components/FollowMeBanner";
import ReviewCarousel from "../../components/reviews/ReviewCarousel";
import "./Home.css";

const Home: React.FC = () => {
  const { state, dispatch } = useData();
  const [showModal, setShowModal] = useState(false);

  // Set the countdown time in seconds
  const countdownTime = 4;

  useEffect(() => {
    if (!state.homePage) {
      fetchHomePage(dispatch);
    }
    if (!state.ignoreSubscribeForm) {
      // Start the countdown timer
      const countdownTimer = setTimeout(() => {
        // After the countdown, show the modal
        setShowModal(true);
      }, countdownTime * 1000);

      // Clean up the timer to avoid memory leaks
      return () => clearTimeout(countdownTimer);
    }
  }, [dispatch, state.homePage, state.ignoreSubscribeForm]);

  const handleCloseModal = () => {
    // Close the modal
    setShowModal(false);
    dispatch({ type: "SET_IGNORE_SUBSCRIBE_FORM", payload: true });
  };

  return (
    <div>
      <SubscribeFormDialog visible={showModal} onClose={handleCloseModal} />

      <div style={{ padding: "0px" }}>
        <CarouselTopPicks />
        <div
          style={
            state.isMobile
              ? {
                marginTop: "25px",
                marginBottom: "20px",
                marginLeft: "25px",
                marginRight: "25px",
              }
              : {
                marginTop: "25px",
                marginBottom: "20px",
                marginLeft: "50px",
                marginRight: "50px",
              }
          }
        >
          {state.homePage && (
            <div
              style={{ width: "100%" }}
              id="content-container"
              dangerouslySetInnerHTML={{
                __html: state.isMobile
                  ? state!.homePage?.MobileContent
                  : state!.homePage?.DesktopContent,
              }}
            ></div>
          )}
          {!state.homePage && <Spin />}
        </div>

        <FollowMeBanner />
        <ReviewCarousel />
      </div>
    </div>
  );
};

export default Home;
